import React from 'react';
import styles from './ChartModal.module.scss';

function ChartModal({ show, child, modalBodyClassName }) {
  if (!show) return null;

  return (
    <div className={styles['topics-categories']}>
      <div className={styles['modal-content']}>
        <div className={`${styles['modal-body']} ${modalBodyClassName}`}>
          {child}
        </div>
      </div>
    </div>
  );
}

export default ChartModal;
